import { useSelector } from "react-redux";

const Protected = ({ children }) => {
  const loggedInUser = useSelector((state) => state.auth.user);
  console.log(loggedInUser)
  const user = useSelector((state) => state.auth.user);
  console.log(user);
  // if (user && user.userDetails && user.statusType === "SUCCESS") {
  if (user && user.statusType === "SUCCESS") {
    return children;
  } 

  return <h2>Protected error</h2>;
};

export default Protected;